import _sfc_main from "./Badge.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.badgeClass }, [_vm._t("default"), _setup.showBadge ? _c("sup", { staticClass: "tui-badge-count" }, [_vm._v(_vm._s(_setup.content))]) : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "b1ab6870"
);
const TuiBadge = __component__.exports;
export {
  TuiBadge as default
};
